module.exports = __webpack_public_path__ + "img/univers_naega.4bd250b0.svg";